// test1
(1 && 0);
